var LoginStore = (function () {
    function LoginStore() {
        this.connected = false;
        this.detail = null;
    }
    LoginStore.prototype.setConnected = function (connected) {
        this.connected = connected;
    };
    LoginStore.prototype.setDetail = function (detail) {
        this.detail = detail;
    };
    return LoginStore;
}());
export { LoginStore };
